
import { getAuthorSms, updateSmsTemplate, updateOpenFlag ,findSmsTemplate} from '@/zsm-api-new/sms.js'
const state = {

}

const mutations = {

}

const actions = {

  /*
  * 获取讲师短信模板列表
  * authorMobile:讲师手机号
  * */
  findSmsTemplate({ commit }, authorMobile) {
    return new Promise((resolve, reject) => {
      findSmsTemplate(authorMobile).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /*
    * 修改模板开启标识
    * openFlag:开启状态 1开启 0关闭
    * templateId: 开启的模板id
* */
  updateOpenFlag({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateOpenFlag(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /*
   * 讲师修改模板具体内容
   * content:推送内容
   * smsType: 1 订单提醒
   * sceneType: 消息类型 ==》zsm_shop_sms_template_dict
   * copyWriter:引流文案
   * linkType:短信类型
   * openFlag:开启状态
   * qrCodeUrl:引流二维码
   * userId:用户id
 * */
  updateSmsTemplate({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateSmsTemplate(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /*
  获取讲师购买后剩余的条数和内容
  * authorMobile:讲师手机号
  * */
  getAuthorSms({ commit }, authorMobile) {
    return new Promise((resolve, reject) => {
      getAuthorSms(authorMobile).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
